const idOf = item => item?.legacyId ?? item?.id ?? item?._id;

export const partnerMatchesSubRegister = (partner, subRegisterId) => {
  if (!subRegisterId || partner?.isActive === false) return false;
  const target = String(subRegisterId);
  const ids = (partner.sub_register_id || partner.sub_registers || []).map(entry => {
    if (!entry) return null;
    if (typeof entry === 'object') return String(idOf(entry));
    return String(entry);
  });
  return ids.includes(target);
};

export const getContactsForSubRegister = (partners = [], subRegisterId, adminContact) => {
  const matched = partners.filter(p => partnerMatchesSubRegister(p, subRegisterId));
  if (matched.length) return matched;
  return adminContact ? [adminContact] : [];
};
